













































import Vue from 'vue';
import _ from 'lodash';
import store from '@/store';
import { mapState, mapGetters } from 'vuex';
import { ViewpointDao } from "@/api/ViewpointDao";
import TeamCreate from '@/components/team/team-create.vue';
import TeamResults from '@/components/team/teams-results.vue';
import TeamCardMenu from '@/components/team/teams-card-menu.vue';
import TeamInviteButton from '@/components/team/team-invite-button.vue';
import TeamViewpointButton from '@/components/team/team-viewpoint-button.vue';

var apiDao: ViewpointDao = new ViewpointDao();

export default Vue.extend({

  name: 'TeamSummary',

  components: {
    'team-create': TeamCreate,
    'team-results': TeamResults,
    'team-card-menu': TeamCardMenu,
    'team-invite-button': TeamInviteButton,
    'team-viewpoint-button': TeamViewpointButton,
  },

  props: {
    teamProp: {
      type: Object,
      default:  () => ({}),
    },
  },

  data() {
    return {
      packageId: this.$store.getters.getPackageId,
      team: {} as any,
      teamScoredChoicesResponse: {} as any, 
      teamFactorsResponse: {} as any, 
      viewpoints: [] as any,
      loadingChoices: true,
      loadingFactors: true,
    };
  },

  created() {
    console.log('[ TeamSummary created() ]:');
    this.loadTeam();
  },

  mounted() {
  },

  watch: {
    getVpGroups(newVal, oldVal) {
      this.loadTeam();
      console.log('watch > getVpGroups changed');
    },
    getVpInstances(newVal, oldVal) {
      this.loadTeam();
      console.log('watch > getVpInstances changed');
    },
    teamProp(newVal, oldVal) {
      this.loadTeam();
      console.log('watch > teamProp changed');
    },
  },

  computed: {
    
     ...mapGetters([
      'getFavourites',
      'getIsLoggedIn',
      'getInstanceId',
      'getVpInstances',
      'getVpInstancesCount',
      'getVpInstanceList',
      'getVpInstanceListCount',
      'getVpGroups',
      'getVpGroupsCount',
      'getVpGroupsList',
      'getVpGroupsListCount',
      'getVpGroupInstances',
      'getVpGroupInstancesCount',
      'getVpGroupInstancesList',
      'getVpGroupInstancesListCount'
    ]),

    loading(): boolean {
      return this.loadingChoices || this.loadingFactors;
    },
   
    isLoggedIn(): any {
      return this.$store.getters.getIsLoggedIn;
    },

    formatDate(): string {
      let newDate: Date = new Date
      let options: object = { year: 'numeric', month: 'long', day: 'numeric' };
      let locale: string = 'en-US';
      return newDate.toLocaleDateString(locale, options);
    },

    teamName(): string {
      if (Object.keys(this.team).length){
        let name: string  = ( this.team.name ? String(this.team.name) : '' );
        let res: string = ( name.length > 8 ? String(name.substring(0, 8)) + '...' : String(name) );
        return res;
      } else {
        return '';
      }
    },

    numberOfTeamMembers(): number {
      if (Object.keys(this.team).length){
        return this.team.users.length + this.team.adminUsers.length;
      } else {
        return 0;
      }
    },

    numberOfSharedViewpoints(): number {
      if (Object.keys(this.team).length){
        return this.team.viewpoints.length;
      } else {
        return 0;
      }
    },

    isTeamLoaded(): boolean {
      return !!Object.keys(this.team).length;
    },

  },

  methods: {

    loadTeam() {
      this.viewpoints = this.getVpInstances;
      if (Object.keys(this.teamProp).length) {
        this.team = this.teamProp;
      } else {
        this.team = {};
      }
      this.loadTeamScoredChoices();
      this.loadTeamFactors();
    },

    async loadTeamScoredChoices(pageSize: number = 0) {
      if (this.team.hasOwnProperty('viewpointId')) {
        this.loadingChoices = true;
        let queryParameters: any = {};
        if (pageSize) {
          queryParameters.pageSize = pageSize;
        }
        let res: any = {};
        await apiDao.getScoredChoices(this.packageId, this.team.viewpointId, queryParameters)
          .then( response => {
            console.log('[ loadTeamScoredChoices() > apiDao.getScoredChoices > RESPONSE ]');
            console.log(response);
            res = response;
          })
          .catch( error => {
            console.log('[ loadTeamScoredChoices() > apiDao.getScoredChoices > ERROR ]');
            console.log(error);
          });
        this.teamScoredChoicesResponse = res;
        this.loadingChoices = false;
      }
    },
    

    async loadTeamFactors() {
      if (this.team.hasOwnProperty('viewpointId')) {
        this.loadingFactors = true;
        let res: any = {};
        await apiDao.getFactors(this.packageId, this.team.viewpointId)
          .then( response => {
            console.log('[ loadTeamFactors() > apiDao.getFactors > RESPONSE ]');
            console.log(response);
            res = response;
          })
          .catch( error => {
            console.log('[ loadTeamFactors() > apiDao.getFactors > ERROR ]');
            console.log(error);
          });
        this.teamFactorsResponse = res;
        this.loadingFactors = false;
      }
    },
    
  },


});

